import React from 'react';
import styled from 'styled-components';
import { H4 } from '../../../Atoms/Typo';

const Component = styled.div`
  ${H4}
  color: ${(props) => props.theme.colors.grey600};
  font-size: 14px;
  height: 20px;
`;

interface DashboardTitleProps {
  title: string;
}

const DashboardTitle = ({ title }: DashboardTitleProps) => {
  return <Component className="voda_dashboard_kor_title">{title}</Component>;
};

export default DashboardTitle;
